import React from 'react';
import { TouchableOpacity } from '@applane/react-core-components';
import { Table, Text, View } from '../../../app-components';
import { appraiseEmployeeListUri } from '../../../Queries/appraiseEmployee';
import { ROUTES } from '../../../Lib/constants';
import { passwordIcon } from '../../../images';

import vars from '../../../theme/vars';
import { IconButton } from '../../../app-components/buttons/Buttons';
import { shorten } from '../../../Lib/helpers';
const { headings } = vars;

const tableItems = {
  lg: {
    columns: [
      {
        header: 'Employee #',
        width: 150,
        render: (props) => {
          return (
            <Text style={{ fontSize: 16, fontFamily: 'Mulish-Medium' }}>
              {props.index + 1}
            </Text>
          );
        },
      },
      {
        header: 'Username',
        type: 'text',
        render: (props) => {
          return (
            <Text style={{ fontSize: 16, fontFamily: 'Mulish-Medium' }}>
              {shorten(props?.item?.username, 18)}
            </Text>
          );
        },
      },
      {
        header: 'First name',
        type: 'text',
        // field: 'firstName',
        render: (props) => {
          return (
            <Text style={{ fontSize: 16, fontFamily: 'Mulish-Medium' }}>
              {shorten(props?.item?.firstName, 18)}
            </Text>
          );
        },
      },
      {
        header: 'Last name',
        type: 'text',
        // field: 'lastName',
        render: (props) => {
          return (
            <Text style={{ fontSize: 16, fontFamily: 'Mulish-Medium' }}>
              {shorten(props?.item?.lastName, 18)}
            </Text>
          );
        },
      },
      {
        header: 'Email',
        type: 'text',
        // field: 'lastName',
        render: (props) => {
          return (
            <Text style={{ fontSize: 16, fontFamily: 'Mulish-Medium' }}>
              {shorten(props?.item?.email, 18)}
            </Text>
          );
        },
      },
      {
        header: 'Status',
        type: 'text',
        render: ({ item }) => {
          return (
            <View
              style={{
                width: 100,
                borderRadius: 15,
                backgroundColor:
                  item?.status === 'Active' ? '#2cbcb1' : '#009dcc',
                alignItems: 'center',
                paddingTop: 5,
                paddingBottom: 5,
              }}>
              <Text style={{ ...headings.h8, color: '#FFF' }}>
                {item?.status}
              </Text>
            </View>
          );
        },
      },
      {
        header: 'Action',
        type: 'text',
        render: ({ item, navigation }) => (
          <TouchableOpacity
            onPress={() => {
              navigation.push({
                view: ROUTES.password.name,
                params: { item, type: 'employee' },
                modal: true,
                modalProps: {
                  backgroundColor: 'transparent',
                },
              });
            }}>
            <IconButton
              description="Change Password"
              tooltipId="daler-password-change"
              icon={passwordIcon}
              label="Change Password"
              labelStyle={{
                fontSize: 18,
                color: '#ffffff',
                fontFamily: 'Mulish-SemiBold',
              }}
            />
          </TouchableOpacity>
        ),
        // type: 'link',
        // link: (props) => ({
        //   view: ROUTES.password.name,
        //   params: {
        //     ...props?.navigation?.state?.params,
        //     type: 'employee',
        //   },
        //   modal: true,
        //   modalProps: {
        //     backgroundColor: 'transparent',
        //   },
        // }),
      },
    ],
  },
};

export default Table({
  reloadEvent: ROUTES.employeeData.name,
  uri: appraiseEmployeeListUri,
  ...tableItems,
  action: ({ item }) => ({
    type: 'link',
    link: {
      view: ROUTES.ViewEmployee.name,
      params: { item: { ...item }, editable: false },
    },
  }),
});
